<template>
  <div class="row q-col-gutter-x-md">
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Vehicle Cap Cost*</label>
      <q-field outlined :value="cost" :error="!isValid">
        <template #control>
          <currency-input @keypress.enter="validController" v-model="cost" class="q-field__input text-right abc-d" />
        </template>
        <template v-slot:error>Required Field.</template>
      </q-field>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Down Payment*</label>
      <q-field outlined :value="downPayment" :error="!isValidDownPayment">
        <template #control>
          <currency-input
            @keypress.enter="validController"
            v-model="downPayment"
            class="q-field__input text-right abc-d"
          />
        </template>
        <template v-slot:error>Required Field.</template>
      </q-field>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Period*</label>
      <q-input
        v-model="period"
        input-class="text-right abc-d"
        outlined
        type="number"
        @keypress.enter="validController"
        :rules="[
          val => (val !== null && val !== '') || 'Required Field.',
          val => (val <= 100 && val >= 1) || 'Period range 1-100 months'
        ]"
      ></q-input>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Monthly Depreciation % Amount*</label>
      <q-input
        outlined
        suffix="%"
        @keypress.enter="validController"
        v-model.number="monthDepAmountPer"
        :rules="[
          val => (val !== null && val !== '') || 'Required Field.',
          val => (val <= 100 && val > 0) || 'Percentage range 0-100'
        ]"
        input-class="abc-d text-right"
      />
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Monthly Interest % Amount*</label>
      <q-input
        outlined
        suffix="%"
        @keypress.enter="validController"
        v-model.number="leaseAmountPer"
        :rules="[
          val => (val !== null && val !== '') || 'Required Field.',
          val => (val <= 100 && val > 0) || 'Percentage range 0-100'
        ]"
        input-class="abc-d text-right"
      />
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Monthly Fee*</label>
      <q-field outlined :value="monthlyFee" :error="!isValidMonthlyFee">
        <template #control>
          <currency-input
            @keypress.enter="validController"
            v-model="monthlyFee"
            class="q-field__input text-right abc-d"
          />
        </template>
        <template v-slot:error>Required Field.</template>
      </q-field>
    </div>
    <div>
      <q-btn :loading="loading" color="primary" :disable="disableController || loading" @click="calculate"
        >Calculate</q-btn
      >
    </div>
  </div>
</template>
<script>
import axios from '../axios'
import round from 'lodash.round'
export default {
  methods: {
    validController() {
      !this.disableController ? this.calculate() : ''
    },
    async calculate() {
      this.show = false
      this.loading = true
      this.$store.commit('calculator/RESET_VALS', '')

      const body = {
        type: 'loan',
        is_least_payment: true,
        amount: this.cost,
        down_payment: this.downPayment,
        period: parseInt(this.period),
        monthly_depreciation_rate: this.monthDepAmountPer,
        monthly_interest_rate: this.leaseAmountPer,
        monthly_payment: this.monthlyFee
      }

      const { data } = await axios.post('calculator/finance', body)

      const { payoff, total_paid, total_interest_paid, residual_value, monthly_payment_average, plan } = data.data
      this.monthlyPaymentFinance = monthly_payment_average
      this.balanceEndFinance = payoff
      this.totalPaidEndOfFinance = total_paid
      this.totalInterestPaidEndFinance = total_interest_paid
      this.financeArr = plan
      this.residualValue = residual_value
      this.loading = false
      this.show = true
    }
  },
  data() {
    return {
      monthlyFee: 50,
      downPayment: 0,
      loading: false,
      cost: 16740,
      period: 24,
      monthDepAmountPer: 2.0,
      leaseAmountPer: 1.0
    }
  },
  computed: {
    financeArr: {
      get() {
        return this.$store.state.calculator.financeArr
      },
      set(val) {
        this.$store.commit('calculator/SET_PAYMENT_DETAILS', val)
      }
    },
    show: {
      get() {
        return this.$store.state.calculator.show
      },
      set(val) {
        this.$store.commit('calculator/SET_SHOW', val)
      }
    },
    residualValue: {
      get() {
        return this.$store.state.calculator.residualValue
      },
      set(val) {
        this.$store.commit('calculator/SET_RESIDUAL_VALUE', val)
      }
    },
    balanceEndFinance: {
      get() {
        return this.$store.state.calculator.balanceEndFinance
      },
      set(val) {
        this.$store.commit('calculator/SET_BALANCE_END_FINANCE', val)
      }
    },
    totalInterestPaidEndFinance: {
      get() {
        return this.$store.state.calculator.totalInterestPaidEndFinance
      },
      set(val) {
        this.$store.commit('calculator/SET_TOTAL_INTEREST_PAID_END_FINANCE', val)
      }
    },
    totalPaidEndOfFinance: {
      get() {
        return this.$store.state.calculator.totalPaidEndOfFinance
      },
      set(val) {
        this.$store.commit('calculator/SET_TOTAL_PAID_END_OF_FINANCE', val)
      }
    },
    monthlyPaymentFinance: {
      get() {
        return this.$store.state.calculator.monthlyPaymentFinance
      },
      set(val) {
        this.$store.commit('calculator/SET_MONTHLY_PAYMENT_FINANCE', val)
      }
    },
    disableController() {
      if (
        this.cost &&
        this.period &&
        this.period > 0 &&
        this.period <= 100 &&
        this.monthlyFee >= 0 &&
        this.monthlyFee !== '' &&
        this.monthlyFee !== undefined &&
        this.monthlyFee !== null &&
        this.monthDepAmountPer > 0 &&
        this.monthDepAmountPer <= 100 &&
        this.leaseAmountPer > 0 &&
        this.leaseAmountPer <= 100 &&
        this.downPayment >= 0 &&
        this.downPayment !== '' &&
        this.downPayment !== undefined &&
        this.downPayment !== null
      )
        return false
      else return true
    },
    isValidLeaseAmout() {
      return this.leaseAmount
    },
    isValidDepAmount() {
      return this.depAmount
    },
    isValid() {
      return this.cost
    },
    isValidDownPayment() {
      if (this.downPayment === undefined || this.downPayment === null || this.downPayment === '') return false
      else return true
    },
    isValidMonthlyFee() {
      if (this.monthlyFee !== '' && this.monthlyFee !== null && this.monthlyFee !== undefined && this.monthlyFee >= 0)
        return true
      else return false
    }
  }
}
</script>

<style lang="scss">
.abc-d {
  color: #000 !important;
}
.form-element-calculator {
  margin: 10px 0px;
}
.calculate-label {
  font-size: 15px;
  color: #027be3;
  font-weight: bold;
}
</style>
